import { sameJson } from "@/utils/general"
import { describe } from "./describe"

const GROUP_GAP = 5 * 60 * 1000

// a row that touches no page is never grouped
const samePages = (a = [], b = []) => a.length > 0 && a.length === b.length && a.every((pageId) => b.includes(pageId))

const joins = (newer, older) => sameJson(newer.actor, older.actor) && samePages(newer.pageIds, older.pageIds) && new Date(newer.at) - new Date(older.at) <= GROUP_GAP

// A row stores the image only when it changed it: a side without one takes it from the other row's same side
const withImage = (side, other) => ("thumbnail" in side || !("thumbnail" in other) ? side : { ...side, thumbnail: other.thumbnail })

// An entry draws each edited page once, where it first drew it: as it was before the first edit and after the
// last. Drawings of moved and deleted pages, which have only one side, stay as they are.
const drawnOnce = (sentences) => {
  let first = new Map() // page id -> the index of its drawing
  let kept = []
  sentences.forEach((sentence) => {
    let [{ kind, pageDiff, key }] = sentence
    if (sentence.length !== 1 || kind !== "drawing" || !pageDiff.before || !pageDiff.after) return kept.push(sentence)
    if (!first.has(key)) return first.set(key, kept.push(sentence) - 1)

    let i = first.get(key)
    let earlier = kept[i][0].pageDiff
    kept[i] = [{ kind, pageDiff: { before: withImage(earlier.before, pageDiff.before), after: withImage(pageDiff.after, earlier.after), labels: { ...earlier.labels, ...pageDiff.labels } }, key }]
  })
  return kept
}

// Rows (newest first) as entries: consecutive rows from the same actor on the same page(s), each within 5 minutes
// of the next, are one entry. Display only: data never merges rows. An entry reads oldest first and repeats no
// headline ("Edited p. 4") the row before it already gave. Rows without wording are left out.
export const group = (activities, ctx) => {
  let runs = []
  activities
    .map((activity) => ({ activity, sentences: describe(activity, ctx) }))
    .filter((row) => row.sentences.length)
    .forEach((row) => {
      let run = runs.at(-1)
      if (run && joins(run.at(-1).activity, row.activity)) run.push(row)
      else runs.push([row])
    })

  return runs.map((run) => {
    let oldestFirst = [...run].reverse()
    return {
      id: oldestFirst[0].activity._id, // stays put while live refresh adds newer rows
      actor: run[0].activity.actor,
      at: run[0].activity.at,
      sentences: drawnOnce(oldestFirst.flatMap(({ sentences }, i) => (i > 0 && sameJson(sentences[0], oldestFirst[i - 1].sentences[0]) ? sentences.slice(1) : sentences))),
    }
  })
}
